import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseDeleteTmaisBadgeProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

type DeleteVariables = {
  id: string
}

export const useDeleteTmaisBadge = ({ onSuccess, onError }: UseDeleteTmaisBadgeProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteTmaisBadge'],
    mutationFn: async ({ id }: DeleteVariables) => privateAxios.delete(`/tmais/badges/${id}`),
    onSuccess,
    onError,
  })
}
